// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1M3Ay","checkboxCol":"Table_checkboxCol__2fmPm","emailCol":"Table_emailCol__B-IE9","actionCol":"Table_actionCol__2LnyJ"};